export const getHeartRateState = (
  events: { hr: number }[],
  baseline: number,
  variation: number
): string => {
  if (!events.length || !baseline || !variation) return 'p0';

  const latestHr = events[events.length - 1].hr;
  const ratioFromBaseline = (latestHr - baseline) / baseline;

  if (ratioFromBaseline > (variation * 2) / 100) {
    return 'p2';
  } else if (ratioFromBaseline > variation / 100) {
    return 'p1';
  } else if (ratioFromBaseline < -((variation * 2) / 100)) {
    return 'p-2';
  } else if (ratioFromBaseline < -variation / 100) {
    return 'p-1';
  }
  return 'p0';
};
